import { withDefaults } from '../../../market-widget/src/shared/settings'
import type { MarketSettings } from '../../../market-widget/src/shared/types'

/**
 * Feed cards carry market insights only when the book chose feed cards as well
 * as a widget. Enabling event-page widgets alone never reaches the feed.
 */
export const feedCardInsightsEnabled = (settings?: MarketSettings): boolean => {
  const resolved = withDefaults(settings)
  return (
    resolved.feed_cards.enabled && (resolved.line_history.enabled || resolved.action_split.enabled)
  )
}
